module.exports = __webpack_public_path__ + "static/media/screenshotdesktoppage3.3f4d55ba.png";